import { createContext } from 'react'

export const ConfiguracoesContext = createContext()
